<template>
  <div class="login">
    <div class=" main-container d-flex flex-column">
      <nav class="navbar navbar-toggleable-md bg-theme nopadding-y">
        <div class=" nopadding-y">
          <a class="navbar-brand nopadding-y" href="#">
            <img src="../../../static/img/new-Logo-color.png" style="width: 150px;">
          </a>
        </div>
      </nav>
        <div class="container-login">
          <div class="form-container" >
            <form @submit.prevent="confirmReset">
              <span class="full-width d-inline-block text-center"
                style="font-size: 20px; font-weight: 600; margin-bottom: 20px">
                Set a New Password
              </span>

              <div class="form-group margin-base-y">
                <label for="new-password" class="control-label">Enter new Password:</label>
                <div class="password-input-wrapper">
                  <input v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" id="new-password"
                    placeholder="Enter new password" class="form-control input-field" @input="clearErrors" />
                  <span class="password-toggle" @click="showNewPassword = !showNewPassword">
                    <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>

                <div class="form-group margin-base-y" style="position: relative; margin-bottom: 5px;">
                  <label for="confirm-password" class="control-label">Confirm Password:</label>
                  <div class="input-container">
                    <div class="password-input-wrapper">
                      <input v-model="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'"
                        id="confirm-password" placeholder="Confirm new password" class="form-control input-field"
                        @input="clearErrors" />
                      <span class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
                        <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </span>
                    </div>
                  </div>
                  <div class="text-danger" v-if="formError" style="position: absolute">{{ formError }}</div>
                </div>
              </div>
              <div class="form-group" style="margin-top: 35px;">
                <button type="submit" class="login-button" :disabled="isLoading">
                  <img src="static/img/loader.gif" v-if="isLoading" class="next-arrow" />
                  <span v-else>Reset Password</span>
                </button>
              </div>
            </form>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import firebase from "../../assets/config/firebase";
import firebaseLib from "firebase";
import swal from "sweetalert";
import api from "../../assets/config/api";

export default {
  name: "ResetPassword",
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      formError: "",
      success: "",
      email: "",
      selectedCompany: null,
      oobCode: "",
      passwordMismatch: false,
      initialLoad: true,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },

  async created() {
    try {
      // Extract query parameters from the URL
      const mainUrlParams = new URLSearchParams(window.location.search);
      this.oobCode = mainUrlParams.get('oobCode') || '';

      // Extract email from continueUrl
      const continueUrl = mainUrlParams.get('continueUrl');
      if (continueUrl) {
        const decodedContinueUrl = decodeURIComponent(continueUrl);
        console.log("Decoded continue URL:", decodedContinueUrl);
        const urlParams = new URLSearchParams(decodedContinueUrl.split('?')[1]);
        this.email = urlParams.get('email') || '';
        console.log("Extracted email:", this.email);
      }

      if (!this.oobCode) {
        throw new Error("Reset code not found.");
      }
      if (!this.email) {
        throw new Error("Email not found in reset link.");
      }

      // Initialize Firebase with the extracted email
      await this.initializeFirebase(false);
    } catch (error) {
      this.formError = error.message;
      if (error.message !== "No account found for this email.") {
        swal("Error", error.message, "error");
      }
    } finally {
      this.initialLoad = false;
    }
  },

  methods: {
    clearErrors() {
      this.formError = "";
      this.passwordMismatch = false;
    },

    showError(message) {
      this.formError = message;
      swal("Error", message, "error");
    },

    async initializeFirebase(showErrors = true) {
      if (!this.email) {
        throw new Error("Email is required to initialize Firebase.");
      }
      try {
        const response = await this.findCompany(this.email);
        if (!response || !response.length) {
          throw new Error("No account found for this email.");
        }
        this.selectedCompany = response[0];
        if (firebase.checkAlreadyConfiguredApp()) {
          await firebase.unconfigureFirebase();
        }
        await firebase.configureFirebase(this.selectedCompany.firebase);

        if (!this.initialLoad || showErrors) {
          try {
            const verifiedEmail = await firebase.ResetCode(this.oobCode);
            if (verifiedEmail !== this.email) {
              console.error("Email mismatch:", {
                verifiedEmail,
                providedEmail: this.email
              });
              throw new Error("The reset link is invalid: Email mismatch.");
            }
          } catch (verifyError) {
            throw new Error(verifyError.code === 'auth/expired-action-code' ? 
              "The password reset link has expired." : 
              verifyError.code === 'auth/invalid-action-code' ? 
              "The password reset link is invalid: " + verifyError.message : 
              verifyError.code === 'auth/user-not-found' ? 
              "No user found for this email." : 
              "Failed to verify reset code: " + verifyError.message);
          }
        }
      } catch (error) {
        if (showErrors) {
          throw new Error(error.message || "Error validating email or reset code.");
        }
        throw error;
      }
    },

    async confirmReset() {
      this.clearErrors();

      if (!this.validatePasswords()) return;

      this.isLoading = true;
      try {
        await this.initializeFirebase(true); 
         await firebase.ResetPassword(this.oobCode, this.newPassword);
        this.success = "Password has been successfully reset.";
        swal("Success!", "You can now log in with your new password.", "success");
        setTimeout(() => {
          this.$router.push({ path: '/', query: {} });
          window.history.replaceState({}, document.title, '/');
        }, 3000);
      } catch (error) {
        const errorMessage = error.code === 'auth/expired-action-code' ? 
          "The password reset link has expired." : 
          error.code === 'auth/invalid-action-code' ? 
          "The password reset link is invalid: " + error.message : 
          error.code === 'auth/user-not-found' ? 
          "No user found for this email." : 
          "Failed to reset password: " + error.message;
        this.showError(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    validatePasswords() {
      if (!this.newPassword || !this.confirmPassword) {
        this.showError("Please enter and confirm your new password.");
        return false;
      }
      
      if (this.newPassword.length < 6) {
        this.showError("Password must be at least 6 characters.");
        return false;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.passwordMismatch = true;
        this.showError("Passwords do not match");
        return false;
      }

      return true;
    },

    async findCompany(emailToFind) {
      try {
        const response = await api.findCompanyByEmail(emailToFind);
        return response;
      } catch (error) {
        throw new Error("Error finding company");
      }
    },
  }
};
</script>

<style scoped>
.password-input-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #777;
}

.password-toggle:hover {
  color: #5EC1A5;
}

.input-field {
  padding-right: 35px; 
}

.text-danger {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: -15px;
}

.error {
  color: #dc3545;
  text-align: center;
}

.success {
  color: #28a745;
  text-align: center;
}


</style>


// WEBPACK FOOTER //
// src/components/Login/ResetPassword.vue